module.exports = __webpack_public_path__ + "img/psicologia.001846f5.png";